module.exports = __webpack_public_path__ + "static/media/enterpriseLogo.7ff3d57a.svg";